export default "__VITE_PUBLIC_ASSET__9c79932e__"